<template>
  <!-- <transition
    enter-active-class="animated faster fadeIn"
    leave-active-class="animated faster fadeOut"
  > -->
  <router-view />
  <!-- </transition> -->
</template>

<script>
export default {
  mounted() {
    var _gaq = _gaq || [];
    _gaq.push(["_setAccount", "UA-29468807-1"]);
    _gaq.push(["_setDomainName", "thecn.com"]);
    _gaq.push(["_trackPageview"]);
    (function() {
      var ga = document.createElement("script");
      ga.type = "text/javascript";
      ga.async = true;
      ga.src =
        ("https:" === document.location.protocol
          ? "https://ssl"
          : "http://www") + ".google-analytics.com/ga.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ga, s);
    })();
  },
};
</script>

<style lang="scss">
.modal-footer {
  background-color: #fff;
}
</style>
